import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
const EditPencilIcon = ({
  color = '#004EBF',
  width = '20',
  height = '20',
  className
}: IconProps) => <SvgIcon className={className} width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} data-sentry-element="SvgIcon" data-sentry-component="EditPencilIcon" data-sentry-source-file="EditPencilIcon.tsx">
		<path d="M2.49896 14.551V17.0844C2.49896 17.3177 2.6823 17.501 2.91563 17.501H5.44896C5.5573 17.501 5.66563 17.4594 5.74063 17.376L14.8406 8.28438L11.7156 5.15938L2.62396 14.251C2.54063 14.3344 2.49896 14.4344 2.49896 14.551ZM17.2573 5.86771C17.5823 5.54271 17.5823 5.01771 17.2573 4.69271L15.3073 2.74271C14.9823 2.41771 14.4573 2.41771 14.1323 2.74271L12.6073 4.26771L15.7323 7.39271L17.2573 5.86771Z" fill={color} data-sentry-element="path" data-sentry-source-file="EditPencilIcon.tsx" />
	</SvgIcon>;
export default EditPencilIcon;